import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Stack,
  Button,
  TextField,
  Container,
  Typography,
  Breadcrumbs,
  Link,
  Switch,
} from '@mui/material';
import accountService from '../services/account.service';
import { loading } from '../reducers/general.reducer';

export default function Page() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [data, setData] = useState({
    id: '',
    name: '',
    active: false,
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: data.id,
      name: data.name,
      submit: null,
    },
    validationSchema: Yup.object({
      id: Yup.string().max(255).required('O ID é obrigatório'),
      name: Yup.string().max(255).required('O NOME é obrigatório'),
    }),
    onSubmit: async (values, helpers) => {
      try {
        dispatch(loading(true));
        const res = await accountService.add({
          id: values.id,
          name: values.name,
          active: data.active,
        });
        navigate(`/dashboard/accounts/edit/${res.id}`);
      } catch (error) {
        console.log(error);
        let message = 'Ops! Algo de errado aconteceu';
        if (error.response && error.response.data && error.response.data.message[0]) {
          message = error.response.data.message.join('\r\n');
        }
        helpers.setStatus({ success: false });
        helpers.setErrors({ submit: message });
        helpers.setSubmitting(false);
      } finally {
        dispatch(loading(false));
      }
    },
  });

  return (
    <>
      <Helmet>
        <title> Adicionar Conta | BMENU </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h4" gutterBottom>
            CONTAS
          </Typography>
        </Stack>
        <Breadcrumbs aria-label="breadcrumb" mb={5}>
          <Link underline="hover" color="inherit" onClick={() => navigate('/dashboard')} style={{ cursor: 'pointer' }}>
            Dashboard
          </Link>
          <Link
            underline="hover"
            color="inherit"
            onClick={() => navigate('/accounts')}
            style={{ cursor: 'pointer' }}
          >
            Contas
          </Link>
          <Typography color="text.primary">Adicionar</Typography>
        </Breadcrumbs>
        <Card>
          <CardContent>
            <Box>
              <form noValidate onSubmit={formik.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      error={!!(formik.touched.id && formik.errors.id)}
                      fullWidth
                      helperText={formik.touched.id && formik.errors.id}
                      label="ID"
                      name="id"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.id}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      error={!!(formik.touched.name && formik.errors.name)}
                      fullWidth
                      helperText={formik.touched.name && formik.errors.name}
                      label="NOME"
                      name="name"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.name}
                    />
                  </Grid>

                  {formik.errors.submit && (
                    <Grid item xs={12} textAlign={'center'}>
                      <Typography color="error" variant="body2" style={{ whiteSpace: 'pre-line' }}>
                        {formik.errors.submit}
                      </Typography>
                    </Grid>
                  )}
                  <Grid item xs={12} textAlign={'right'}>
                    <Switch
                      checked={data && data.active}
                      color="success"
                      onChange={() => {
                        setData({ ...data, active: !data.active });
                      }}
                      name="active"
                    />
                    <Button variant="contained" type="submit">
                      SALVAR
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Box>
          </CardContent>
          <Divider />
        </Card>
        {/* <Stack direction="row" alignItems="center" justifyContent="center" mt={5}>
          <Button variant="text" size="small" onClick={() => navigate(-1)}>
            VOLTAR
          </Button>
        </Stack> */}
      </Container>
    </>
  );
}
